import React, { useRef, useState } from 'react';

import tobeor from 'tobeor';

import { TableRow, ButtonBase, TableCell, TextField, Popover } from '@mui/material';

import { connect } from 'react-redux';

import { SortableElement, sortableHandle } from 'react-sortable-hoc';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import DragIcon from '@mui/icons-material/DragIndicator';
import FilterIcon from '@mui/icons-material/FilterList';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

import Node from '../../../../../common/Node';
import Filters from '../../../../../common/Filters';
import PredicateChain from '../../../../../common/PredicateChain';
import ArrowTooltipCss from '../../../../../common/ArrowTooltipCss';
import UiRendererSettings from '../../../../../common/UiRendererSettings';
import TrplSelect from '../../../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../../../common/TrplControls/TrplCheckbox';
import UiPidsConstructor from '../../../UiPidsConstructor/UiPidsConstructor';

import {
  getRstDataMap,
  getLastRstData,
  getFormsSelectValues,
  isNotPlaceholderFilter,
} from '../../../../../utils';

const DragHandle = sortableHandle(({ classes }) => (
  <div style={{}} className={classes.rowDragHandle}>
    <DragIcon className={`drag-handle-icon ${classes.boundValueDragIcon}`} />
  </div>
));

export default connect((state) => ({
  jels: state.jels,
}))(SortableElement(
  ({
    item,
    jels,
    form,
    classes,
    rowIndex,
    modalData,
    setupRbox,
    itemIndex,
    groupIndex,
    formConcepts,
    addInnerRstCb,
    removeInnerRst,
    openFrmEditModal,
    isPidsChainDuplicate,
    onGroupRstFieldChange,
    onRemoveRstFromGroupClick,
  }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [renderSettingOpened, setRenderSettingOpened] = useState(false);
    const rendernRef = useRef(null);

    const onFiltersClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const onFiltersClose = () => {
      setAnchorEl(null);
    };

    const openFilters = Boolean(anchorEl);

    const initialFilters = item.trpl_filters;

    let filtersRstDataMap;
    let editObjectForms;

    const isRst = !item.type || item.type === 'predicate';
    const isCustom = item.type === 'custom';
    const rowConcept = item.concept_key ? formConcepts[item.concept_key] : form.concept;

    let showObjEditableFrm;
    let lastRst;
    if (!item.type || item.type === 'predicate') {
      lastRst = getLastRstData(item.pid, rowConcept, setupRbox);

      showObjEditableFrm =
      ((item === undefined && item.type === undefined) || (item.type !== 'function')) &&
      (lastRst &&  item.obj_editable)
      ? lastRst.type === 'OBJECT'
      : false;
    }

    if (isRst && lastRst && lastRst && lastRst.oid) {
      filtersRstDataMap = getRstDataMap(null, lastRst.oid, setupRbox);
      editObjectForms = getFormsSelectValues(jels, lastRst.oid, setupRbox);
    }

    const setFiltersToState = (filters) => {
      const cleanedfilters = filters
        .filter(isNotPlaceholderFilter)
      
      onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'trpl_filters', cleanedfilters);
    };

    const setCustomComponentChange = (key, value) => {
      onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, key, value);
    };

    const isDuplicate = isPidsChainDuplicate(item.pid);

    const rendererSelectOptions = [
      { title: 'Regular', value: 'none' },
    ];

    if (isRst && lastRst) {
      if (lastRst.bounds)
        rendererSelectOptions.push({ title: 'Checkboxes', value: 'multi_prdc_checkboxes' });

      if (lastRst.type === 'IMAGE')
        rendererSelectOptions.push({ title: 'Signature', value: 'signature' });

      if (tobeor(lastRst.type, ['STRING', 'TEXTAREA', 'EMAIL']) && !lastRst.bounds)
        rendererSelectOptions.push(
          { title: 'HTML/text', value: 'html' },
          { title: 'HTML/text editor', value: 'html_text_editor' }
        );
    }

    const rendererValue = rendererSelectOptions.find((option) => option.value === item.render_widget);

    const handleRendererChange = (path, value, key) => {
      const { rowIndex, groupIndex, itemIndex } = path;

      onGroupRstFieldChange(rowIndex, groupIndex, itemIndex, key, value, true);
    };

    return (
      <TableRow
        className={`${isDuplicate && classes.mandatoryField}`}
        style={{
          background: `${!lastRst && !item.type ? '#FFD3B5' : ''}`,
          borderBottom: '1px solid #c4c4c4',
        }}>
        <Popover
          id={`filters-popover-${itemIndex}`}
          anchorEl={anchorEl}
          open={openFilters}
          onClose={onFiltersClose}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Filters
            nodes={setupRbox}
            defaultBg={true}
            ancestor={lastRst && lastRst.oid}
            filterByNodeTitle={true}
            callbacks={{
              setFiltersToParentState: setFiltersToState,
            }}
            loaded={true}
            rstDataMap={filtersRstDataMap}
            initialFilters={initialFilters}
          />
        </Popover>
        <TableCell className={classes.tCell}>
          <div className={classes.alignCenter}>
            <div style={{ width: '55px' }} className={classes.alignCenter}>
              <ClearIcon
                color="secondary"
                className={`${classes.mr5} ${classes.pointer}`}
                style={{ fontSize: 20 }}
                onClick={() => {
                  onRemoveRstFromGroupClick(modalData.rowIndex, modalData.groupIndex, itemIndex);
                }}
              />

              <div>
                <DragHandle classes={classes} className={`${classes.pointer}`} editable={item.editable} />
              </div>
            </div>
          </div>
        </TableCell>
        <TableCell className={classes.tCell} title='title' style={{ minWidth: '100px', opacity: item.hide_title ? 0.5 : 1 }}>
          <TextField
            fullWidth
            size='small'
            placeholder={lastRst && lastRst.title}
            value={item.title || ''}
            onChange={(e) =>
              onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'title', e.target.value)
            }
          />
        </TableCell>
        <TableCell className={classes.tCell} title='hide title'>
          <TrplCheckbox
            className={classes.checkboxGray}
            value={item.hide_title || false}
            checked={item.hide_title}
            onChange={(e) =>
              onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'hide_title', e.target.checked)
            }
          />
        </TableCell>

        {isCustom ? 
          <TableCell className={classes.tCell}/> :
          <TableCell className={classes.tCell} title='editable'>
            <TrplCheckbox
              className={classes.checkboxGray}
              value={item.editable || ''}
              checked={`${item.editable === undefined || item.editable}` === 'true'}
              onChange={(e) =>
                onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'editable', e.target.checked)
              }
            />
          </TableCell>
        }
        
        {isCustom ? 
          <TableCell className={classes.tCell}/> :
          <TableCell className={classes.tCell} title='required'>
            <TrplCheckbox
              className={classes.checkboxGray}
              value={item.required || ''}
              checked={`${item.required}` === 'true'}
              onChange={(e) =>
                onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'required', e.target.checked)
              }
            />
          </TableCell>
        }

        <TableCell className={classes.tCell}>
          <div className={classes.alignCenter}>
            {item.concept_key ? <span className={classes.mr5}>{item.concept_key}</span> : null}
            <Node
              isLink
              size="xs"
              nodeId={rowConcept}
              node={setupRbox[rowConcept]}
              nodes={setupRbox}
            />
          </div>
        </TableCell>

        {isCustom ?
          <TableCell className={classes.tCell}>
            <UiPidsConstructor
              setup_rbox_light={setupRbox}
              custom_ancestor={item.custom_ancestor}
              initial_layout={item.custom_component}
              custom_pid={item.custom_pid}
              form_ancestor={rowConcept}
              isForm={true}
              callbacks={{
                setCustomComponentChange: setCustomComponentChange,
              }}
            />
          </TableCell>
        :

        <TableCell className={classes.tCell}>
          <div style={{
            height: '28px',
            padding: '2px',
            display: 'flex',
            paddingRight: '5px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          {isRst ? (
            <React.Fragment>
              <div className={classes.alignCenter} style={{ width: '-webkit-fill-available' }}>
                <PredicateChain
                  mode="edit"
                  showType={true}
                  disableChain={!item.pid}
                  rst={item.pid}
                  index={itemIndex}
                  rstIdIndex={itemIndex}
                  props={{
                    groupIndex: groupIndex,
                    objIndex: rowIndex,
                    index: itemIndex,
                  }}
                  ancestor={rowConcept}
                  addInnerRstCb={addInnerRstCb}
                  onRemoveRstCb={removeInnerRst}
                />

                {isRst && lastRst && lastRst.type === 'BOOLEAN' ?
                  <React.Fragment>
                    <div
                      ref={rendernRef}
                      className={`${classes.mr5} ${classes.pointer}`}
                      onClick={() => setRenderSettingOpened(true)}
                    >
                      <strong
                        style={{
                          padding: '3px',
                          color: item.renderer ? '#347CFF' : '9EA1BE',
                        }}
                      > R
                      </strong>
                    </div>
                    <Popover
                      id={`render-popover-${lastRst.id}`}
                      anchorEl={rendernRef.current}
                      open={renderSettingOpened}
                      onClose={() => setRenderSettingOpened(false)}
                      transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <UiRendererSettings
                        isForm={true}
                        data={lastRst}
                        path={{ rowIndex: modalData.rowIndex, groupIndex: modalData.groupIndex, itemIndex }}
                        classes={classes}
                        component={item}
                        handleRendererChange={handleRendererChange}
                      />
                    </Popover>
                  </React.Fragment>
                : null}

                {isDuplicate || !lastRst ?
                  <ArrowTooltipCss text={`${!lastRst ? 'No restrictions applied to this row' : 'This view already contains same predicate'}`}>
                    <ErrorIcon
                      style={{
                        color: '#DD5900',
                        marginLeft: '5px',
                        height: '18px',
                      }}
                    />
                  </ArrowTooltipCss>
                : null}
              </div>
            </React.Fragment>
            ) : (
              <TextField
                label="Func"
                value={item.func || ''}
                onChange={(e) =>
                  onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'func', e.target.value)
                }
              />
            )}
          </div>
        </TableCell>}

        <TableCell className={classes.tCell}>
          {isRst && lastRst && rendererSelectOptions.length > 1 ? (
            <div
              className={`${classes.alignCenter} ${classes.mr20}`}
            >
              <TrplSelect
                margin="none"
                complicatedValues
                placeholder='Select renderer'
                value={(rendererValue && rendererValue.value) || 'none'}
                values={rendererSelectOptions}
                onChange={(e) => {
                  if (e.target.value === 'none') e.target.value = '';
                  onGroupRstFieldChange(
                    modalData.rowIndex,
                    modalData.groupIndex,
                    itemIndex,
                    'render_widget',
                    e.target.value,
                  );
                }}
              />
            </div>
          ) : null}
        </TableCell>

        <TableCell className={classes.tCell}>
          {isRst && lastRst &&
            lastRst.type === 'OBJECT' && (
              <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px'}}>
                <FilterIcon
                  className={`${classes.actionIcon} ${initialFilters && initialFilters.length ? 'selected' : ''}`}
                  onClick={onFiltersClick}
                />
                <div style={{ marginLeft: '5px' }}>Obj filter</div>
              </div>
            )
          }
        </TableCell>

        <TableCell className={classes.tCell}>
          {isRst && lastRst ? (
            lastRst.type === 'OBJECT' ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
              <TrplCheckbox
                className={classes.checkboxGray}
                value={item.obj_editable || ''}
                checked={`${item.obj_editable}` === 'true'}
                onChange={(e) =>
                  onGroupRstFieldChange(
                    modalData.rowIndex,
                    modalData.groupIndex,
                    itemIndex,
                    'obj_editable',
                    e.target.checked,
                  )
                }
              />
              <div style={{ marginLeft: '-22px' }}>Obj edit</div>
              </div>
            ) : lastRst.type === 'STRING' ? (
              <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                <TrplCheckbox
                  className={classes.checkboxGray}
                  checked={item.autocomplete}
                  onChange={(e) =>
                    onGroupRstFieldChange(
                      modalData.rowIndex,
                      modalData.groupIndex,
                      itemIndex,
                      'autocomplete',
                      e.target.checked,
                    )
                  }
                />
                <div style={{ marginLeft: '-22px' }}>Autocomplete</div>
              </div>
            ) : null
          ) : null}
        </TableCell>

        <TableCell className={classes.tCell}>
          {showObjEditableFrm && (
            <div style={{display: 'flex', marginRight: '20px'}}>
              <TrplSelect
                margin="none"
                complicatedValues
                values={editObjectForms}
                placeholder='Select on edit click form'
                firstChilds={
                  <React.Fragment>
                    <ButtonBase
                      style={{ textTransform: 'none' }}
                      onClick={() => {
                        openFrmEditModal(rowIndex, groupIndex, itemIndex, {concept: lastRst.oid}, true);
                      }}
                      className={`${classes.btnGray} ${classes.mb5}`}
                    >
                      Create form <AddIcon className={`btn-gray-icon ${classes.btnGrayIcon}`} />
                    </ButtonBase>
                  </React.Fragment>
                }
                value={item.obj_editable_frm}
                onChange={(e) => {
                  onGroupRstFieldChange(
                    modalData.rowIndex,
                    modalData.groupIndex,
                    itemIndex,
                    'obj_editable_frm',
                    e.target.value
                  );
                }}
              />

              <ButtonBase
                disabled={!item.obj_editable_frm || item.obj_editable_frm === 'none'}
                style={{
                  opacity: `${(!item.obj_editable_frm || item.obj_editable_frm === 'none') ? '0.5' : ''}`,
                }}
              >
                <EditIcon
                  style={{ display: 'flex', opacity: '1' }}
                  className={classes.editFrmIcon}
                  onClick={() => {
                    openFrmEditModal(rowIndex, groupIndex, itemIndex, jels.jelData[item.obj_editable_frm], true);
                  }}
                />
              </ButtonBase>
            </div>
          )}
        </TableCell>

        {isCustom ? null :
          <TableCell title='optional' className={classes.tCell}>
            <TrplCheckbox
              className={classes.checkboxGray}
              value={item.optional || ''}
              checked={`${item.optional}` === 'true'}
              onChange={(e) =>
                onGroupRstFieldChange(modalData.rowIndex, modalData.groupIndex, itemIndex, 'optional', e.target.checked)
              }
            />
          </TableCell>
        }
      </TableRow>
    );
  }
));
